import { uniqueId } from "../../others/oneliners";
import { SpanSkeleton } from "../skeletonTemplates/skeletons";

interface props {
    skeleton?: boolean;
}

const MapSection = ({ skeleton }: props): JSX.Element => {
    if (skeleton) return <MapSectionSkeleton />
    return (
        <div className="w-full max-w-[1000px]">
            <h3>Location</h3>
            <span className="block mb-4 text-gray-400">{'Kigali city, Ruhurura.  KK 309 st'}</span>
            <iframe
                title={uniqueId()}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d510497.1596364993!2d29.250927616685395!3d-1.6018969672227144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca42ba4412995%3A0xeb7a3b7e5681a72d!2sKigali%20Serena%20Hotel!5e0!3m2!1sen!2srw!4v1665510708194!5m2!1sen!2srw"
                width="600"
                height="250"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="!w-full rounded-xl bg-slate-400"
                // onLoad={() => console.log("LOADED IFRAME")}
                // onError={() => alert('te')}
            ></iframe>
        </div>
    )
}

export default MapSection

export const MapSectionSkeleton = (): JSX.Element => {
    return (
        <div className="flex flex-col gap-2 w-full">
            <h3>Location</h3>
            <SpanSkeleton width="w-[320px]" />
            <div className="animate-pulse bg-slate-400 h-56 w-full rounded-xl"></div>
        </div>
    )
}

// eslint-disable-next-line no-lone-blocks
{/*
 
*/ }